export { SalaryReport } from './SalaryReport.main';
